module.exports = __webpack_public_path__ + "img/5c9a18f.png";